module.exports = __webpack_public_path__ + "SC03-5.01a1612e.atlas";